import { type ReactNode } from 'react';
import { PolicyProvider } from '@trinity/access-policy/react';
import { useApplicationAllowedActions } from '@trinity/chat-components/containers/UserApplications/useApplicationAllowedActions.js';
import { useAppSelector } from '@/store';

/**
 * Exposes what the signed-in user may do in the active brand and application to `useCan`/`<Can>`,
 * from `GET /v1/users/allowed-actions`. Must sit below the brand and application containers.
 * Until the actions load (or after logout) everything gated is denied. UI gating only; chat-api
 * enforces access on every request.
 */
export const ApplicationPolicyStateProvider = ({ children }: ChildrenProps): ReactNode => {
  const userIdentifier = useAppSelector((state) => state.user.identifier) || null;

  return <PolicyProvider allowedActions={useApplicationAllowedActions(userIdentifier)}>{children}</PolicyProvider>;
};
